import React from "react";
import proxiadLogo from "../../assets/images/clients/proxiad.png";
import pragmaitLogo from "../../assets/images/clients/pragmait.png";
import nexelsiLogo from "../../assets/images/clients/nexelsi.png";

/**
 * Logo carousel matching the design template's `.section.trusted` block.
 * Track is duplicated so the CSS marquee animation (translateX 0 -> -50%)
 * loops seamlessly. Hover pauses the animation.
 *
 * Two card variants, matching the template:
 *   - `wordmark`: the brand owns a full logo, embedded as a local PNG asset
 *     (extracted from the template's inline base64). The text label is
 *     hidden and only revealed if the image fails to load.
 *   - `favicon`: a Google-favicon icon shown next to the brand name as text.
 *     Both icon and text render together.
 */

const fav = (domain) => `https://www.google.com/s2/favicons?sz=256&domain=${domain}`;

const LOGOS = [
  { key: "proxiad", alt: "Logo PROXIAD", src: proxiadLogo, label: "PROXIAD", variant: "wordmark" },
  { key: "dba", alt: "Logo DBA Groupe", src: fav("fr-dba.com"), label: "DBA Groupe", variant: "favicon" },
  { key: "softcorp", alt: "Logo SOFTCORP", src: fav("softcorp.fr"), label: "SOFTCORP", variant: "favicon" },
  { key: "pragmait", alt: "Logo pragmaIT", src: pragmaitLogo, label: "pragmaIT", variant: "wordmark" },
  { key: "nexelsi", alt: "Logo NEXELSI", src: nexelsiLogo, label: "NEXELSI", variant: "wordmark", cardClass: "mk-logo-card-nexelsi" },
  { key: "freelance-factory", alt: "Logo Freelance Factory", src: fav("freelance-factory.fr"), label: "Freelance Factory", variant: "favicon" },
  { key: "inspiire", alt: "Logo INSPIIRE", src: fav("inspiire.fr"), label: "INSPIIRE", variant: "favicon" },
  { key: "akabi", alt: "Logo AKABI", src: fav("akabi.eu"), label: "AKABI", variant: "favicon" },
];

const renderCard = (logo, suffix) => {
  const isWordmark = logo.variant === "wordmark";
  return (
    <div key={`${logo.key}-${suffix}`} className={`mk-logo-card ${logo.cardClass || ""}`.trim()}>
      <img
        className={isWordmark ? "mk-logo-real mk-logo-user" : "mk-logo-favicon"}
        src={logo.src}
        alt={logo.alt}
        loading="lazy"
        onError={(e) => {
          e.currentTarget.style.display = "none";
          const fb = e.currentTarget.nextElementSibling;
          if (fb) fb.style.display = "inline-block";
        }}
      />
      {isWordmark ? (
        <span className="mk-logo-wordmark" style={{ display: "none" }}>{logo.label}</span>
      ) : (
        <span className="mk-logo-text">{logo.label}</span>
      )}
    </div>
  );
};

const Trusted = () => (
  <section className="mk-section mk-trusted" id="trusted" data-testid="section-trusted">
    <div className="mk-wrap">
      <div className="mk-trusted-head mk-reveal">
        <h2>Ils nous font confiance</h2>
      </div>
      <div className="mk-logo-marquee mk-reveal" aria-label="Logos des clients et partenaires">
        <div className="mk-logo-track">
          {LOGOS.map((l) => renderCard(l, "a"))}
          {LOGOS.map((l) => renderCard(l, "b"))}
        </div>
      </div>
    </div>
  </section>
);

export default Trusted;
